import { Modal } from "antd";
// import styled from "styled-components";
import { ButtonCancel, ButtonConfirm } from "../Layout/Buttons";
import { useTranslation } from "react-i18next";
import { ModalContent, ModalButtons } from "../../style/Modal";

// const ModalContent = styled.div`
//   padding: 2em;
// `;

// const ModalButtons = styled.div`
//   display: flex;
//   gap: 1em;
//   align-items: center;
//   justify-content: flex-end;
//   margin-top: 3em;
// `;

interface IFormModalProps {
  title?: string;
  open: boolean;
  width?: string | number | undefined;
  isConfirmButtonDisabled?: boolean;
  children?: JSX.Element;
  onCancel: () => void;
  onConfirm: () => void;
}

const FormModal = ({
  title,
  open,
  width = 1200,
  isConfirmButtonDisabled = false,
  children,
  onCancel,
  onConfirm,
}: IFormModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={title}
      footer={null}
      closable={false}
      onCancel={onCancel}
      destroyOnHidden={true}
      width={width}
    >
      <ModalContent>
        {children}

        <ModalButtons>
          <ButtonCancel onClick={onCancel}>{t("button-cancel")!}</ButtonCancel>

          <ButtonConfirm onClick={onConfirm} disabled={isConfirmButtonDisabled}>
            {t("button-confirm")!}
          </ButtonConfirm>
        </ModalButtons>
      </ModalContent>
    </Modal>
  );
};

export default FormModal;
